import { render, staticRenderFns } from "./PagoData.vue?vue&type=template&id=48a3e815&"
import script from "./PagoData.vue?vue&type=script&lang=js&"
export * from "./PagoData.vue?vue&type=script&lang=js&"
import style0 from "./PagoData.vue?vue&type=style&index=0&id=48a3e815&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports